import { render } from "./IconItemCategoryStudy.vue?vue&type=template&id=33469411"
import script from "./IconItemCategoryStudy.vue?vue&type=script&lang=js"
export * from "./IconItemCategoryStudy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__